export const SERVICES = {
    FRONTEND: {
        title: "Front-end services",
        keyWord: "ReactJS",
        description: `is renowned for its extensibility, adjustability and convenience. 
        Many of the developers acknowledge it one of the best JavaScript open source libraries. 
        It makes possible the creation of such complex software as web browser and mobile application 
        user interfaces that accommodate to the strictest standards.`,
        services: [
            "Service 1",
            "Service 2",
            "Service 3"
        ],
        justify: "flex-start"
    },
    SEO: {
        title: "Seo",
        keyWord: "Seo",
        description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, 
        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris 
        nisi ut aliquip ex ea commodo consequat.`,
        services: [
            "Service 4",
            "Service 5",
            "Service 6"
        ],
        justify: "center"
    },
    LIVE_COACHING: {
        title: "Live coaching",
        keyWord: "Coaching",
        description: `duis aute irure dolor in reprehenderit in voluptate 
        velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, 
        sunt in culpa qui officia deserunt mollit anim id est laborum.`,
        services: [
            "Service 7",
            "Service 8",
            "Service 9"
        ],
        justify: "flex-end"
    }
}